import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView, SectionCard } from "@/base";
import { accountBillingListView } from "@/pages/accountBillingListView";

// The Surety account's Billing tab (BRK-S411, BRK-S445; BRK-S187's Invoices
// tab before it): the account's invoices, payment receipts, statements and
// credit memos on the shared list view (BRK-S255), embedded under the
// profile's own header. Each row downloads its PDF and an invoice opens its
// page; nothing about payment beyond the broker-safe status (D5).
export function AccountInvoicesPanel({ accountId }: { accountId: string }) {
  const { authedRequest, authedBlob } = useAuth();
  const def = useMemo(
    () =>
      accountBillingListView({
        request: authedRequest,
        fetchBlob: authedBlob,
        accountId,
      }),
    [authedRequest, authedBlob, accountId],
  );
  return (
    // In the panel well, as every box on the page is (BRK-S502).
    <SectionCard title="Billing">
      {/* The embedded list draws no header of its own; the wireframe's says
          what is (and is not) billed here. */}
      <p className="mb-3 text-sm text-brk-dim">
        Invoices, payment receipts, statements and credit memos for this account
        and its submissions. Bid bonds aren’t invoiced.
      </p>
      <BaseListView def={def} embedded />
    </SectionCard>
  );
}
